import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Target, Clock, Eye } from 'lucide-react';
const values = [{
  text: 'Clarity over jargon',
  icon: Eye,
  color: 'text-blue-600'
}, {
  text: 'Measurable outcomes over vanity metrics',
  icon: Target,
  color: 'text-[#ff8a33]'
}, {
  text: 'Strategic long-term relationships over quick wins',
  icon: Clock,
  color: 'text-emerald-500'
}, {
  text: 'Privacy and data respect',
  icon: Shield,
  color: 'text-purple-500'
}];
export function About() {
  return <section id="about" className="py-24 bg-white relative overflow-hidden" data-id="element-1">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-2">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#000 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-3" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-5">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gray-100 text-gray-600 text-xs font-semibold uppercase tracking-wider mb-6" data-id="element-7">
              About Me
            </div>

            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-8">
              Who You'll Actually Be Working With
            </h2>

            <div className="prose prose-lg text-gray-600 mb-8" data-id="element-9">
              <p className="mb-4" data-id="element-10">
                I'm a hands-on operator who blends data, marketing, systems,
                automation, and execution. I only work with a small number of
                partners at a time — no layers, no outsourcing, no confusion.
              </p>
              <p className="mb-4 font-medium text-gray-900 border-l-4 border-[#ff8a33] pl-4" data-id="element-11">
                I'm new to offering this publicly, not new to the capabilities.
              </p>
              <p data-id="element-12">
                That means early partners get direct access and execution
                quality that normally sits behind a much larger price tag — in
                exchange for transparent feedback and permission to build case
                studies around outcomes.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8" data-id="element-13">
              {values.map((value, index) => <div key={index} className="flex items-center gap-3 p-4 rounded-xl bg-gray-50 border border-gray-100 hover:shadow-md transition-shadow" data-id="element-14">
                  <div className={`p-2 rounded-lg bg-white shadow-sm ${value.color}`} data-id="element-15">
                    <value.icon className="w-5 h-5" data-id="element-16" />
                  </div>
                  <span className="text-sm font-medium text-gray-700" data-id="element-17">
                    {value.text}
                  </span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-18">
            <div className="aspect-square rounded-2xl overflow-hidden bg-gray-100 shadow-2xl relative z-10" data-id="element-19">
              <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/8b02460a-931f-4c06-b2dc-ac265f7f4475.png?v=1765276885" alt="Christopher Brissette" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-20" />

              {/* Gradient overlay for text readability if needed */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-21" />
            </div>

            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -left-6 z-20 bg-white p-6 rounded-2xl shadow-xl border border-gray-100 max-w-xs" data-id="element-22">
              <div className="flex items-center justify-between mb-2" data-id="element-23">
                <p className="text-xs text-gray-500 uppercase font-semibold tracking-wider" data-id="element-24">
                  Current Status
                </p>
                <span className="relative flex h-2 w-2" data-id="element-25">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-26"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-27"></span>
                </span>
              </div>
              <p className="text-sm font-bold text-gray-900 flex items-center gap-2" data-id="element-28">
                Accepting New Partners
              </p>
              <div className="mt-3 pt-3 border-t border-gray-100" data-id="element-29">
                <p className="text-xs text-gray-500 uppercase font-semibold tracking-wider mb-1" data-id="element-30">
                  Availability
                </p>
                <p className="text-sm font-bold text-gray-900" data-id="element-31">
                  Limited openings for new partners
                </p>
              </div>
            </div>

            {/* Background Pattern */}
            <div className="absolute -z-10 top-10 -right-10 w-full h-full border-2 border-[#ff8a33]/20 rounded-2xl" data-id="element-32" />
            <div className="absolute -z-20 top-20 -right-20 w-full h-full bg-gray-50 rounded-2xl" data-id="element-33" />
          </motion.div>
        </div>
      </div>
    </section>;
}